import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const HELPIGO_BLUE = '#2563eb';

export default function HomeClosingSection() {
    useEffect(() => {
        if (!document.querySelector('script[src="https://tally.so/widgets/embed.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://tally.so/widgets/embed.js';
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    return (
        <Box
            id="demo-form"
            component="section"
            sx={{
                py: { xs: 10, md: 14 },
                background: `linear-gradient(165deg, ${HELPIGO_BLUE} 0%, #1d4ed8 42%, #172554 100%)`,
                color: '#fff',
                position: 'relative',
                overflow: 'hidden',
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: '-30%',
                    right: '-10%',
                    width: 'min(520px, 70vw)',
                    height: 'min(520px, 70vw)',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(153,187,227,0.35) 0%, transparent 70%)',
                    pointerEvents: 'none',
                },
            }}
        >
            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <Typography
                        variant="overline"
                        sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 700, letterSpacing: '0.14em' }}
                    >
                        Hemen başlayın
                    </Typography>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            fontWeight: 800,
                            fontSize: { xs: '1.85rem', sm: '2.25rem', md: '2.65rem' },
                            letterSpacing: '-0.03em',
                            mt: 1,
                            mb: 2,
                            lineHeight: 1.2,
                        }}
                    >
                        Demo ile Helpigo’yu mağazanızda deneyin
                    </Typography>
                    <Typography
                        sx={{
                            color: 'rgba(255,255,255,0.88)',
                            fontSize: { xs: '1rem', md: '1.1rem' },
                            lineHeight: 1.65,
                            mb: 4,
                            maxWidth: 480,
                            mx: 'auto',
                        }}
                    >
                        Kısa bir form veya doğrudan kayıt; ekibimiz kurulumda yanınızda. Kredi kartı zorunluluğu yoktur.
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        }}
                    >
                        <Button
                            variant="contained"
                            size="large"
                            data-tally-open="wMV9kA"
                            data-tally-layout="modal"
                            data-tally-width="400"
                            data-tally-auto-close="0"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                                bgcolor: '#fff',
                                color: HELPIGO_BLUE,
                                fontWeight: 700,
                                textTransform: 'none',
                                px: 4,
                                py: 1.5,
                                borderRadius: 2,
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                                '&:hover': { bgcolor: '#f1f5f9', color: '#1d4ed8' },
                            }}
                        >
                            Demo talep et
                        </Button>
                        <Button
                            component={RouterLink}
                            to="/register"
                            variant="outlined"
                            size="large"
                            sx={{
                                borderColor: 'rgba(255,255,255,0.55)',
                                color: '#fff',
                                fontWeight: 600,
                                textTransform: 'none',
                                px: 4,
                                py: 1.5,
                                borderRadius: 2,
                                '&:hover': {
                                    borderColor: '#fff',
                                    bgcolor: 'rgba(255,255,255,0.08)',
                                },
                            }}
                        >
                            Kayıt ol
                        </Button>
                    </Box>
                </motion.div>
            </Container>
        </Box>
    );
}
